import { commentTable } from '$lib/supabase';
import { validate as uuidValidate } from 'uuid';
import DOMPurify from 'dompurify';
// import { supabaseClient } from '$lib/supabase';

const GET_COL_SET = '*'; // include all columns

/**
 * addComment: Inserts a new comment into the comments table
 *
 * @param id <string> The id of the comment
 * @param created_at <string> The date of the comment
 * @param message <string> The Markdown text of the comment
 * @param postId <string> The UUID of the post to associate the comment with
 * @param replied_to_username <string> the author of the post the user is commenting on
 * @param created_by <string> The UUID of the commenter
 * @param author_username <string> The display name of the user
 * @param notifications <NotificationArray> The any at mentions of other users in the message
 * @returns <PostgrestFilterBuilder> object of the Supabase PostgreSQL query | <boolean>false if error.
 */
export const addComment = async (
	id: string,
	created_at: Date,
	message: string,
	post_id: string,
	replied_to_username: string,
	author_username: string,
	created_by: string,
	replied_to_id: string
) => {
	// console.log('api', notifications);
	try {
		// const validPostId = uuidValidate(post_id);

		// if (!validPostId) {
		// 	throw new Error('Invalid post Id');
		// }

		const cleanedMessage = DOMPurify.sanitize(message);
		// const CLEAN_NOTIFICATIONS = DOMPurify.sanitize(JSON.stringify(notifications));
		// const CLEAN_JSON_NOTIFICATIONS = JSON.parse(CLEAN_NOTIFICATIONS);

		const retVal = await commentTable('comments')
			.insert([
				{
					id: id,
					created_at: created_at,
					message: cleanedMessage,
					post_id: post_id,
					replied_to_username: replied_to_username,
					author_username: author_username,
					created_by: created_by,
					replied_to_id: replied_to_id
					// published: false // New comments are not published by default
				}
			])
			.select();

		return retVal;
	} catch (error) {
		console.error('Error adding comment:', error);
		throw new Error('Failed to add comment');
	}
};

// TODO: This needs to get the comments from the specific post id
/**
 * getCommentsAll - Gets all post comments
 *
 * @param <number>limit - no parameters
 * @returns { data, error } where data is a list of supabase chat table objects
 *
 * TODO: better validation of ID and return object
 *
 */
export const getCommentsAll = async (postId: string) => {
	try {
		const validPostId = uuidValidate(postId);

		if (!validPostId) {
			throw new Error('Invalid postId');
		}
		const { data, error: downloadError } = await commentTable('comments')
			.select(GET_COL_SET)
			.eq('post_id', postId)
			.order('created_at', { ascending: true });

		if (downloadError) {
			throw downloadError;
		}

		return { data, error: null };
	} catch (error) {
		return { data: null, error }; // Handle errors appropriately
	}
};

/**
 * deleteComment - Deletes a comment by ID
 *
 * @param {string} commentId - The ID of the comment to delete
 * @returns { success, error } where success indicates whether the deletion was successful and error contains any error encountered during the process
 *
 * TODO: better validation of ID and return object
 *
 */
export const deleteComment = async (commentId: string) => {
	try {
		const validCommentId = uuidValidate(commentId);

		if (!validCommentId) {
			throw new Error('Invalid commentId');
		}

		const { error } = await commentTable('comments').delete().eq('id', commentId);

		if (error) {
			console.error('An error occurred:', error);
			return false;
		}

		return { success: true, error: null };
	} catch (error) {
		return { success: false, error }; // Handle errors appropriately
	}
};
